import React from 'react';
import {
  KANBAN_COLUMN,
  KANBAN_COLUMN_HEADER,
  KANBAN_COLUMN_BODY,
  KANBAN_COLUMN_DOT,
  KANBAN_GRID_TEMPLATE,
  KANBAN_COLUMN_MIN_WIDTH,
} from './kanbanStyles';

export function KanbanBoard({ scrollRef, children, className = '' }) {
  return (
    <div ref={scrollRef} className={`overflow-x-auto p-2 sm:p-3 ${className}`}>
      <div
        className="flex gap-2 min-w-max lg:grid lg:min-w-0 lg:w-full lg:gap-2"
        style={{
          gridTemplateColumns: KANBAN_GRID_TEMPLATE,
        }}
      >
        {children}
      </div>
    </div>
  );
}

export function KanbanColumn({ columnId, title, count, onDragOver, onDrop, children }) {
  const dotClass = KANBAN_COLUMN_DOT[columnId] || 'bg-prodia-text-muted';

  return (
    <div
      className={KANBAN_COLUMN}
      style={{ minWidth: KANBAN_COLUMN_MIN_WIDTH }}
      onDragOver={onDragOver}
      onDrop={onDrop}
    >
      <div className={`${KANBAN_COLUMN_HEADER} flex items-center gap-1.5`}>
        <span className={`w-2 h-2 rounded-full flex-shrink-0 ${dotClass}`} aria-hidden="true" />
        <h3 className="text-[11px] font-semibold text-prodia-text-primary truncate flex-1 min-w-0" title={title}>
          {title}
        </h3>
        <span
          className="flex-shrink-0 text-[10px] font-medium tabular-nums text-prodia-text-muted bg-prodia-background border border-prodia-border rounded-full px-1.5 min-w-[1.125rem] text-center leading-4"
          aria-label={`${count}件`}
        >
          {count}
        </span>
      </div>
      <div className={KANBAN_COLUMN_BODY}>{children}</div>
    </div>
  );
}

export function KanbanColumnEmpty() {
  return (
    <div className="py-2 px-1.5 text-center rounded-md border border-dashed border-prodia-border bg-prodia-surface/50">
      <p className="text-[10px] font-medium text-prodia-text-secondary">案件なし</p>
      <p className="text-[9px] text-prodia-text-muted mt-0.5 leading-tight">ここにカードをドラッグできます</p>
    </div>
  );
}
